import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContent4Up";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const errorMessages = checkItemArrayIntegrity(items);
    errorMessages.push(...checkMediaIntegrity(items, MEDIA_PRIORITY));

    return errorMessages;
}
